<template>
    <div v-if="shippingMode" class="mb-3" :class="{ 'text-center': centeredText }">
        <p class="title" v-if="amountLeft > 0 && price.gross">
            {{
                __('Ha még :amountLeft értékben vásárolsz, a SZÁLLÍTÁS INGYENES GLS-sel történő kézbesítés esetén!', {
                    amountLeft: formatCurrency(amountLeft),
                })
            }}
        </p>
        <p class="title" v-if="!price.gross">
            {{
                __('Ha még :amountLeft értékben vásárolsz, a SZÁLLÍTÁS INGYENES GLS-sel történő kézbesítés esetén!', {
                    amountLeft: formatCurrency(amountLeft),
                })
            }}
        </p>
        <p class="title" v-if="amountLeft <= 0">
            {{ __('A szállítás erre a rendelésre ingyenes GLS-sel történő kézbesítés esetén!') }}
        </p>
    </div>
</template>

<script>
import Vue from 'vue'
import {mapState} from 'vuex'
import currencyFormatter from '../mixins/currencyFormatter';
import {sumBy} from 'lodash';

export default {
    name: 'FreeShippingFinderWidget',
    mixins: [currencyFormatter],
    props: {
        centeredText: {
            required: false,
            default: true,
            type: Boolean
        },
        cartEmpty: {
            required: false,
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            shippingMode: null,
            gross: 0
        }
    },

    created() {
        this.load()
    },

    methods: {
        async load() {
            try {
                const response = await axios.get('/api/min-value-shipping-discounts', {
                    params: {
                        empty: this.cartEmpty
                    }
                })

                this.shippingMode = response.data
            } catch (exception) {
                console.error('Could not load the free shipping state.')
            }
        },
        formatCurrency(amount) {
            return Vue.options.filters.currency(amount, this.currencyFormat(this.shippingMode.currency))
        }
    },

    computed: {
        ...mapState('cart', [
            'price',
            'items',
        ]),

        totalItemPrice() {
            return sumBy(this.items, (item) => parseFloat(item.price.gross) * item.quantity)
        },

        totalItemOriginalPrice() {
            return sumBy(this.items, (item) => parseFloat(item.originalPrice) * item.quantity)
        },

        amountLeft() {
            if (!this.shippingMode) {
                return 0
            }

            if (this.items.length <= 0) {
                return this.shippingMode.discountGrossRequirement
            }

            if (this.price.gross <= 0) {
                return 0
            }

            return this.totalItemPrice >= this.shippingMode.discountGrossRequirement
                ? 0
                : this.shippingMode.discountGrossRequirement - Math.max(0, this.totalItemPrice)
        },
    },

    watch: {
        amountLeft() {
            this.$bus.$emit('free-shipping-amount-left', this.amountLeft)
        },

        price() {
            this.load()
        },
    }
}
</script>

<style scoped>
.title {
    font-size: 1.1rem;
}
</style>
